import type { CartItem } from '@/lib/types/cart.types.ts';

export type TimeSlot = {
	startTime: string;
	endTime: string;
};

export type SlotsResponse = {
	date?: string;
	slots?: Array<TimeSlot>;
};

export enum OrderDefaults {
	NotSpecified = 'not_specified',
}

export type OrderSubservice = {
	carSubServiceId: number;
	startDate: string;
};

export type OrderPayload = {
	fullName: string;
	vehicleBrand: string | OrderDefaults.NotSpecified;
	vehicleModel: string | OrderDefaults.NotSpecified;
	phoneNumber: string;
	countryPhoneCode: string;
	email: string;
	carYear: number;
	carLicense: string | OrderDefaults.NotSpecified;
	isCompanyOrder: boolean;
	language: string;
	subServicesDto: Array<OrderSubservice>;
	additionalInfoOrNull: any;
	isInvoice: boolean;
	paymentMethod: string;
	homePageId: number;
};

export type LastOrder = {
	services: Array<CartItem>;
	payload: OrderPayload;
	response: {
		fullName: string;
		id: number;
		vehicleBrand: string;
		vehicleModel: string;
	};
};
